var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96406 4.80078H3.16406C2.61178 4.80078 2.16406 5.2485 2.16406 5.80078V12.6648C2.16406 13.2171 2.61178 13.6648 3.16406 13.6648H3.96406C4.51635 13.6648 4.96406 13.2171 4.96406 12.6648V5.80078C4.96406 5.2485 4.51635 4.80078 3.96406 4.80078Z",
    stroke: "#225B14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 6.35099V11.6643C4.96484 12.1948 5.17556 12.7035 5.55063 13.0785C5.9257 13.4536 6.43441 13.6643 6.96484 13.6643H11.5468C11.9125 13.6643 12.2679 13.5441 12.5585 13.3222C12.8491 13.1003 13.0586 12.789 13.1548 12.4363L14.4602 7.64433C14.5275 7.39711 14.5369 7.1377 14.4877 6.88625C14.4385 6.6348 14.332 6.39808 14.1765 6.19448C14.0209 5.99089 13.8205 5.82589 13.5908 5.71233C13.3612 5.59876 13.1084 5.53967 12.8522 5.53966H10.1222V3.00033C10.1222 2.6467 9.9817 2.30756 9.73165 2.05752C9.4816 1.80747 9.14247 1.66699 8.78884 1.66699H8.76484C8.5441 1.66703 8.32683 1.72187 8.13251 1.82659C7.93819 1.93131 7.77292 2.08264 7.65151 2.26699L4.96484 6.35099Z",
    stroke: "#225B14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.f524dd9cd7b2054613e8b96e2983e717.svg";
export { ForwardRef as ReactComponent };